import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { UserService } from '../../services/user.service';
import { RoleService } from '../../services/role.service';
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import * as moment from "moment";
import { saveAs } from 'file-saver/src/FileSaver';
import { maxYearFunction } from '../../_helpers/utility';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    styles: [`
        :host ::ng-deep .p-datatable-gridlines p-progressBar {
            width: 100%;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class AdminComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    public hide: boolean = true;
    errorMessage = '';
    statuses: any[];
    searchBy: any[];
    rowGroupMetadata: any;
    totalRecords: 0;
    virtualDatabase: any;
    userlist: any;
    roleIds;
    userdetail: any;
    public item: any[] = [];
    genders: any = [];
    loading: boolean;
    paginationOption;
    private lastTableLazyLoadEvent: LazyLoadEvent;
    calvalue: Date;
    ucalvalue: Date;
    dcalvalue: Date;
    yearRange;
    minYear = environment.minYear;
    startDate: Date;
    endDate: Date;
    downloadFlg: boolean;
    downloadUserList: any;
    searchby;
    @ViewChild("dt", { static: false }) public dt: Table;
    @ViewChild("pDropDownId1", { static: false }) pDropDownId1: Dropdown;
    @ViewChild("pDropDownId2", { static: false }) pDropDownId2: Dropdown;
    fullName: any;
    email: any;
    cityname: any;
    statename: any;
    countryname: any;
    zipcode: any;
    createdby: any;
    updatedby: any;
    roles: any[] = [];
    gender: string;

    constructor(private userService: UserService, private roleService: RoleService, private router: Router,  private messageService: MessageService, private confirmationService: ConfirmationService) { }

    ngOnInit() {
        this.paginationOption = environment.pagination;
        this.yearRange = this.minYear + ":" + maxYearFunction();
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false }
        ];
        this.searchBy = [
            { label: 'Created On', value: "created_at" },
            { label: 'Last Modified On', value: "updated_at" }
        ];
        this.genders = [
            { label: 'Male', value: 'Male' },
            { label: 'Female', value: 'Female' },
            { label: 'Other', value: 'Other' },
        ];
        this.downloadFlg = false;  
        this.loadRoles();      
    }

    

    clear() {
        this.startDate = null;
        this.endDate = null;
        this.searchby = '';
        this.dt.filter('', 'fullName', 'contains');
        this.dt.filter('', 'email', 'contains');
        this.dt.filter('', 'countryname', 'contains');
        this.dt.filter('', 'statename', 'contains');
        this.dt.filter('', 'cityname', 'contains');
        this.dt.filter('', 'zipcode', 'contains');
        this.dt.filter('', 'dob', 'dateIs');
        this.dt.filter('', 'gender', 'contains');
        this.dt.filter('', 'created_at', 'dateIs');
        this.dt.filter('', 'createdby', 'contains');
        this.dt.filter('', 'updated_at', 'dateIs');
        this.dt.filter('', 'updatedby', 'contains');

        this.fullName = '';
        this.email = '';
        this.cityname = '';
        this.statename = '';
        this.countryname = '';
        this.createdby = '';
        this.updatedby = '';
        this.zipcode = '';
        this.gender = '';
        this.calvalue = null;
        this.ucalvalue = null;
        this.dcalvalue = null;
        this.pDropDownId1.clear(null);
        if (this.pDropDownId1) {
            this.pDropDownId1.value = null;
        }
        this.pDropDownId2.clear(null);
        if (this.pDropDownId2) {
            this.pDropDownId2.value = null;
        }
    }

    loadUsers(event: LazyLoadEvent) {
        this.lastTableLazyLoadEvent = event;
        var query = "?filterByDisable=false";
        var pagenumber = 1;
        var params = "";
        var rows;
        if (event.first != undefined && event.first == 0) {
            pagenumber = event.first + 1;
        } else if (event.first != undefined && event.first > 0) {
            pagenumber = (event.first / event.rows) + 1;
        } else {
            pagenumber = 1;
        }
        if (event.rows != undefined) {
            rows = event.rows;
        } else {
            rows = 10;
        }
        if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
            params += "&filterByDate=" + this.searchby.value;
            params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
            params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
        }
        if (event.filters != undefined && event.filters["fullName"] != undefined) {
            params += "&filterByFullName=" + event.filters["fullName"].value;
        }
        if (event.filters != undefined && event.filters["email"] != undefined) {
            params += "&filterByemail=" + event.filters["email"].value;
        }
        if (event.filters != undefined && event.filters["countryname"] != undefined) {
            params += "&filterByCountryName=" + event.filters["countryname"].value;
        }
        if (event.filters != undefined && event.filters["statename"] != undefined) {
            params += "&filterByStateName=" + event.filters["statename"].value;
        }
        if (event.filters != undefined && event.filters["cityname"] != undefined) {
            params += "&filterByCityName=" + event.filters["cityname"].value;
        }
        if (event.filters != undefined && event.filters["zipcode"] != undefined) {
            params += "&filterByZipcode=" + event.filters["zipcode"].value;
        }
        if (event.filters != undefined && event.filters["status"] != undefined) {
            params += "&filterByStatus=" + event.filters["status"].value;
        }
        if (event.filters != undefined && event.filters["gender"] != undefined) {
            params += "&filterByGender=" + event.filters["gender"].value;
        }
        if (event.filters != undefined && event.filters["dob"] != undefined) {
            const createdAt = moment(event.filters["dob"].value).format("YYYY-MM-DD");
            params += "&filterByDob=" + createdAt;
        }
        if (event.filters != undefined && event.filters["created_at"] != undefined) {
            const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
            params += "&filterByCreatedAt=" + createdAt;
        }
        if (event.filters != undefined && event.filters["createdby"] != undefined) {
            params += "&filterByCreatedby=" + event.filters["createdby"].value;
        }
        if (event.filters != undefined && event.filters["updated_at"] != undefined) {
            const createdAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
            params += "&filterByUpdatedAt=" + createdAt;
        }
        if (event.filters != undefined && event.filters["updatedby"] != undefined) {
            params += "&filterByUpdatedby=" + event.filters["updatedby"].value;
        }
        // at the time of download hide pagination option
        if (this.downloadFlg == false) {
            if (params != undefined && params != "") {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
            } else {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
            }
        } else {
            if (params != undefined && params != "") {
                query += params;
            }
        }
        if (event.sortField != undefined && event.sortOrder != undefined) {
            var orderBy = "";
            if (event.sortOrder == 1) {
                orderBy = "DESC";
            } else {
                orderBy = "ASC";
            }
            query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
        }
        let querystring = "filterByroleNames=admin,academymanager";
        this.roleService.searchRoleDetails(querystring).pipe(takeUntil(this.destroy$)).subscribe(data => {
            if (data && data.data && data.data.items.length > 0) {
                if (event.filters != undefined && event.filters["rolename"] != undefined) {
                    this.roleIds = data.data.items.filter(role => role.user_role_name === event.filters["rolename"].value).map(role => role.id);
                } else {
                    this.roleIds = data.data.items.map(role => role.id);
                }
                query += "&filterByrollIds=" + this.roleIds;
                this.userService.getUserList(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
                    if (this.downloadFlg === true) {
                        this.exportExcelSheet(data.data.items);
                    } else {
                        this.loading = false;
                        this.userlist = data.data.items;
                        this.totalRecords = data.data.totalCount;
                    }
                },
                err => {
                    this.errorMessage = err.error.message;
                });
            }
        },
        err => {
            this.errorMessage = err.error.message;
        });
    }

    loadRoles() {
        var querystring = "filterByroleNames=admin,academymanager";
        this.roleService.searchRoleDetails(querystring).pipe(takeUntil(this.destroy$)).subscribe(data => {
            if (data && data.data && data.data.items.length > 0) {
                this.roles = data.data.items.map(role => {
                    return { label: role.user_role_name, value: role.user_role_name }
                });
            }
        },
        err => {
            this.errorMessage = err.error.message;
        });
    }

    deleteUser(user) {
        this.confirmationService.confirm({
            message: `
            <h4 style="margin:0;">Are you sure?</h4>
            <p style="margin-top:10px;">
                You want to delete this record ?
            </p>
            `,
            // message: 'Are you sure you want to delete this image ?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Confirm',
            rejectLabel: 'Cancel',
            acceptIcon: '',
            rejectIcon: '' ,    
            accept: () => {
                var disableStatus;
                if (user.disable == false) {
                    disableStatus = true;
                } else {
                    disableStatus = false;
                }
                var userData = '{"disable":' + disableStatus + '}';
                this.userService.updateUser(user.id, userData).pipe(takeUntil(this.destroy$)).subscribe(data => {
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Admin User Deleted', life: 3000 });
                        this.loadUsers(this.lastTableLazyLoadEvent);
                    },
                    err => {
                        this.errorMessage = err.error.message;
                    }
                );
            },
            reject: () => {
                //this.getUserDetails(user.id);
            }
        });
    }

    func(prop, val) {
        var jsonStr = '{"' + prop + '":"' + val + '"}';
        return JSON.parse(jsonStr);
    }

    addNewUser() {
        this.router.navigate(['/manage/admin/add']);
    }

    viewAdmin(id) {
        this.router.navigate(['/manage/admin/view/' + id]);
    }

    editUser(id) {
        this.router.navigate(['/manage/admin/' + id]);
    }

    findIndexById(id: string): number {
        let index = -1;
        for (let i = 0; i < this.userlist.length; i++) {
            if (this.userlist[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    changeStatus(user) {
        this.confirmationService.confirm({
            // message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(user.fullName)) + '?',
            // header: 'Confirm',
            // icon: 'pi pi-exclamation-triangle',
                 message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change this status ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 
            accept: () => {

                var userData = '{"status":' + user.status + '}';
                this.userService.updateUser(user.id, userData).pipe(takeUntil(this.destroy$)).subscribe(
                    data => {
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Admin Status Updated', life: 3000 });
                        this.getUserDetails(user.id);
                    },
                    err => {
                        this.errorMessage = err.error.message;
                    }
                );
            },
            reject: () => {
                this.getUserDetails(user.id);
            }
        });
    }

    getUserDetails(id) {
        this.userService.getUserDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.userdetail = data;
                this.userdetail.created_at = new Date(this.userdetail.created_at);
                this.userdetail.name = this.userdetail.firstName + ' ' + this.userdetail.lastName;
                if (this.userdetail.status == "true") {
                    this.userdetail.statusactive = true;
                } else {
                    this.userdetail.statusactive = false;
                }
                this.userlist[this.findIndexById(id)] = this.userdetail;

            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    /** 
     * Use to add more columns in the table.
    */
    // addColumns() {
    //     var showp1Table = this.el.nativeElement.querySelector(".p1-table-columns");
    //     showp1Table.classList.remove('hide-columns');
    //     showp1Table.classList.add('show-columns');
    //     var hidep2Table = this.el.nativeElement.querySelector(".p2-table-columns");
    //     hidep2Table.classList.remove('show-columns');
    //     hidep2Table.classList.add('hide-columns');
        
    // }

    // /** 
    // * Use to remove more columns in the table.
    // */
    // removeColumns() {
    //     var showp2Table = this.el.nativeElement.querySelector(".p2-table-columns");
    //     showp2Table.classList.remove('hide-columns');
    //     showp2Table.classList.add('show-columns');
    //     var hidep1Table = this.el.nativeElement.querySelector(".p1-table-columns");
    //     hidep1Table.classList.add('hide-columns');
    //     hidep1Table.classList.remove('show-columns');
    // }
    setDownloadFlag() {
        this.downloadFlg = false;
    }

    exportExcel() {
        this.downloadFlg = true;
        this.loadUsers(this.lastTableLazyLoadEvent);
    }

    exportExcelSheet(userlist) {
        var propertiesRemove = ['fullName', 'citycode', 'portfolioImages', 'timeZoneOffset', 'updatedBy', 'address', 'id', 'role', 'profilepic', 'createdby', 'updatedby', 'disable', 'countrycode', 'statecode', 'created_at', 'updated_at'];
        this.downloadUserList = userlist;
        this.downloadUserList.forEach(function (item) {
      
            if (item.status) {
                item['status'] ='Active';
            }else{
                item['status'] ='In-Active';
            }
            propertiesRemove.forEach(function (prop) {
                delete item[prop];
            });
        });
        this.downloadUserList.forEach(function (item) {
            propertiesRemove.forEach(function (prop) {
                delete item[prop];
            });
        });
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.downloadUserList);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });
            this.saveAsExcelFile(excelBuffer, "Admin");
        });
        this.downloadFlg = false;
    }


    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            let filename;
            filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
            saveAs(data, filename);
        });
    }
        addColumns() {
        this.hide = false;

    }

    /**
    * Use to remove more columns in the table.
    */
    removeColumns() {
        this.hide = true;
    }
    

    ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  
}
